module.exports = __webpack_public_path__ + "static/media/sidebar_schuhe.079b1b5d.jpg";